// text

const cutAway = (text, limit) => {
  if (!text) return;


  if (text.length >= limit) {
    return `${text.slice(0, limit)}...`
  } else {
    return text;
  }
}

// Arrays
const sliceAndReturn = (arrayList, toBeReturned) => {
  let returningArray = arrayList;
  if (arrayList && arrayList.length >= toBeReturned) {
    returningArray = arrayList && arrayList.slice(0, toBeReturned);
  }


  return returningArray;

}

// Function to convert seconds to minutes


const toMinutes = (seconds:number, raw?:boolean)=>{
// return Math.round(parseInt(seconds, 10)/60);
let finalValue = seconds/60;
let pre = parseFloat(finalValue.toPrecision(1));

if(raw) return finalValue
return pre;
}



const formatTime = (seconds)=>{
const hours = Math.floor(seconds / 60 / 60);

const minutes = Math.floor(seconds / 60) - (hours * 60);

return{
  hours,
  minutes
}

}




let startTime = null;

const resetTimer = () => {
  startTime = new Date();
  localStorage.setItem('startTime', startTime);
  return startTime;
}


const startTimer = () => {
  startTime = new Date(localStorage.getItem('startTime') || resetTimer());
  // start timer
  setInterval(function () {
    let secsDiff = new Date().getTime() - startTime.getTime();
    let save = Math.floor(secsDiff / 1000);
    localStorage.setItem("track", JSON.stringify(save));
  }, 1000);


  return setInterval(() => { localStorage.getItem("track") }, 1000);
}




export { cutAway, sliceAndReturn, startTimer, resetTimer, toMinutes, formatTime };